export default __webpack_public_path__ + "static/media/004-boat.df4d58f6.svg";